import ContactsHome from '@/views/contacts/ContactsHome'
import ContactList from '@/views/contacts/ContactList'
import ContactTagsAdmin from '@/views/contacts/ContactTagsAdmin'
import ContactCreate from '@/views/contacts/ContactCreate'
import ContactExport from '@/views/contacts/ContactExport.vue'


export default {
  path: '/contacts',
  component: ContactsHome,
  children: [
    {
      path: '/',
      name: 'ContactsHome',
      props: true,
      component: ContactList,
      children:[
        {
          path: 'tags',
          name: 'TagsAdmin',
          props: true,
          component: ContactTagsAdmin,
        },
        {
          path: 'new',
          name: 'ContractCreate',
          component: ContactCreate,
        },
        {
          path: 'export',
          name: 'ContactExport',
          component: ContactExport,
        },
      ]
    },
  ]
}
